export default __webpack_public_path__ + "static/hero.png";